import React from "react";
import {
  Avtar1,
  Avtar2,
  Background_about1,
  Background_about2,
  Background_about3,
  Background_about4,
  Media_img,
  Rectangle_dots,
  Red_Dots,
  Red_arrow,
  Ring_circle,
  Wave_line,
} from "../../helper/imageConstant";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Pagination } from "swiper/modules";
import ImageSection from "../../components/common/ImageSection";

const AboutUs = () => {
  return (
    <>
      <ImageSection name={"About us"} />
      <section className="relative p-4 my-5  lg:my-10 xl:pb-14 3xl:pb-20 overflow-hidden">
        <div className="lg:mx-10 xl:mx-14 2xl:ml-[140px] 2xl:mr-0 3xl:mx-40 4xl:max-w-[1520px] 4xl:mx-auto ">
          <div className="grid grid-cols-6 lg:grid-cols-12 gap-6 lg:gap-10 2xl:gap-16 3xl:gap-28">
            <div className="col-span-6 3xl:col-span-7">
              <div className="relative flex justify-center gap-6 lg:gap-6">
                <div className="h-full w-full ">
                  <img
                    src={Background_about2}
                    alt=""
                    className="object-cover"
                  />
                </div>
                <div className="h-full w-full mt-10 lg:mt-16 xl:mt-14 3xl:mt-20 ">
                  <img
                    src={Background_about1}
                    alt=""
                    className="object-cover"
                  />
                </div>
                <div
                  className="absolute -bottom-7 right-[50%] translate-x-[50%] lg:-bottom-[12%] lg:left-[7%] xl:-bottom-[11%] xl:left-[18%]
                  3xl:-bottom-[10%] 3xl:left-[18%]"
                >
                  <div className="w-36 lg:w-44 xl:w-48 2xl:w-48 3xl:w-64 h-full">
                    <img src={Ring_circle} alt="" className="bg-cover" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-span-6 3xl:col-span-5 flex justify-center items-start">
              <div className="lg:mt-12 xl:mt-16 3xl:mt-20 w-full lg:p-4 2xl:p-2 flex flex-col gap-4 lg:gap-4 3xl:gap-6">
                <div className="">
                  <span
                    className="py-2 px-3 sm:py-2 sm:px-4 bg-[#A5302E] text-white text-xs xs:text-sm md:text-base
                   3xl:text-lg uppercase leading-none"
                  >
                    About us
                  </span>
                </div>
                <div className="">
                  <h3
                    className="text-[#A5302E] text-4xl xs:text-[40px] md:text-6xl lg:text-4xl xl:text-4xl 3xl:text-5xl 
                    font-semibold flex flex-wrap leading-tight 3xl:leading-snug lg:pr-20 xl:pr-20
                    italic"
                  >
                    Discover Our <br className="" /> Fabric Collections
                  </h3>
                </div>
                <p className="text-base xs:text-base md:text-xl lg:text-lg xl:text-lg 3xl:text-xl lg:leading-relaxed 3xl:leading-relaxed pr-5 xs:pr-5 md:pr-48 lg:pr-0 xl:pr-10 2xl:pr-36 3xl:pr-24">
                  Explore our thoughtfully curated fabric collections, perfect
                  for all your creative pursuits.
                </p>
                <ul className="list-disc pl-5 text-base xs:text-xl md:text-xl lg:text-lg xl:text-base 3xl:text-xl">
                  <li className="py-1 3xl:py-2 pl-5 text-[#A5302E]">
                    <h4 className="">Silk Sensations</h4>
                  </li>
                  <li className="py-1 3xl:py-2 pl-5">
                    <h4 className="">Cotton Comfort</h4>
                  </li>
                  <li className="py-1 3xl:py-2 pl-5">
                    <h4 className="">Denim Classics</h4>
                  </li>
                  <li className="py-1 3xl:py-2 pl-5">
                    <h4 className="">Linen Elegance</h4>
                  </li>
                  <li className="py-1 3xl:py-2 pl-5">
                    <h4 className="">Shaded Chiffon</h4>
                  </li>
                </ul>
              </div>
              <div
                className="lg:hidden absolute bottom-[15%] right-0 xs:bottom-[16%] xs:right-0 md:bottom-[12%] md:right-0 lg:top-[80%] lg:-left-[8%] xl:top-[85.5%] xl:-left-[5%]
             2xl:top-[85.5%] 2xl:-left-[5%] 4xl:top-[80.5%] 4xl:-left-[3%]"
              >
                <div className="w-24 md:w-28 lg:w-32 2xl:w-36 4xl:w-44 h-full">
                  <img
                    src={Rectangle_dots}
                    alt=""
                    className="object-cover max-w-full mx-auto"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="relative p-4 my-5 lg:my-2 xl:pb-10 overflow-hidden">
        <div className="lg:mx-10 xl:mx-14 2xl:mx-32 3xl:mx-40 4xl:max-w-[1520px] 4xl:mx-auto ">
          <div className="grid grid-cols-6 lg:grid-cols-12 gap-6 lg:gap-0">
            <div className="col-span-6 lg:col-span-8 flex justify-center items-center order-2 lg:order-1">
              <div className="bg-[#FDE7E7] w-full lg:p-4 flex justify-center items-center border-l-[#A5302E] border-l-[6px] lg:border-l-[17px]">
                <p
                  className="fonts p-4 lg:p-8 text-xs xs:text-base md:text-xl lg:text-lg xl:text-lg 3xl:text-xl leading-5 xl:leading-loose 3xl:leading-[46px] font-normal
                  text-justify"
                >
                  Established in the year 1985, we,
                  <span className="text-[#A5302E]">"Vikas Fashion"</span> , are
                  one of the leading organizations, involved in manufacturing,
                  supplying and exporting a comprehensive collection of
                  Trimming, Ribbons and Laces & Cords. Our range encompasses
                  Designer Tassel Laces, Designer Laces, Velvet & Sequence Lace,
                  Handmade Trims, Polyester Trims, Sequence Trims, Beaded
                  Jacquard Ribbon, Jacquard Ribbons and Metallic Jacquard
                  Ribbons, to name a few. We manufacture all our products
                  utilizing premium raw material and latest technology to ensure
                  that final output meets with international quality norms &
                  latest fashion trends.
                </p>
              </div>
              <div
                className="hidden xl:inline-block absolute lg:top-[80%]
                 lg:-left-[8%] xl:top-0 xl:-left-[5%]
             2xl:top-0 2xl:left-20 4xl:top-0 4xl:left-[6%]"
              >
                <div className="">
                  <img src={Wave_line} alt="" className="" />
                </div>
              </div>
            </div>
            <div className="col-span-6 lg:col-span-4 order-1 lg:order-2 flex justify-center">
              <div className="h-full w-fit">
                <img
                  src={Background_about3}
                  alt=""
                  className="max-w-full object-contain mx-auto lg:mx-0 lg:mr-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="relative p-4 my-5 lg:my-2 xl:py-10 overflow-hidden">
        <div className="lg:mx-10 xl:mx-14 2xl:ml-[80px] 2xl:mr-[110px] 3xl:mx-40 4xl:max-w-[1520px] 4xl:mx-auto ">
          <div className="grid grid-cols-6 lg:grid-cols-12 gap-6 lg:gap-10 3xl:gap-0">
            <div className="col-span-6 lg:col-span-4">
              <div className="w-52 lg:w-fit lg:h-full">
                <img
                  src={Background_about4}
                  alt=""
                  className="float-left pr-4 lg:pr-0 lg:float-none max-w-full lg:ml-auto "
                />
              </div>
              <div
                className="lg:hidden fonts p-0 text-xs xs:text-base md:text-xl lg:text-xl leading-snug lg:leading-relaxed 3xl:leading-[40px] font-normal
                  break-words text-justify"
              >
                <p className="">
                  To execute our business operations smoothly, we have developed
                  a modern infrastructure, which is located at Surat (Gujarat,
                  India). Internally segregated into various units, our
                  infrastructure is equipped with latest machinery, tools,
                  instruments and technology that are needed for carrying out
                  production process smoothly and accurately. It is managed by a
                  team of expert professionals, who utilize all <br /> <br />
                  the available resources for making a qualitative range as per
                  clients needs. We also have a sophisticated showroom named
                  Harish B. Jariwala at Surat, which is the place, we display
                  all our products. Apart from this, we conduct several tests on
                  final output to ensure zero defect.
                  <br /> <br />
                  Under the able and efficient guidance of our mentor, 'Mr.
                  Vishal Jariwala', who has rich experience in this domain, we
                  have carved a niche for ourselves in the market. His ethical
                  business practices, client-centric approaches and sound
                  strategies have enabled us to muster a huge clientele across
                  the Indian Subcontinent, East Asia and North Europe.
                </p>
              </div>
            </div>
            <div className="hidden col-span-6 lg:col-span-8 lg:flex justify-center items-center">
              <div className="w-full flex justify-center items-center">
                <div
                  className="fonts p-0 text-base xs:text-base md:text-xl lg:text-base 3xl:text-xl lg:leading-loose 2xl:leading-[40px] 3xl:leading-[40px] font-normal
                  tracking-widest	break-words flex flex-col gap-10 text-justify lg:text-left"
                >
                  <p className="text-justify">
                    To execute our business operations smoothly, we have
                    developed a modern infrastructure, which is located at Surat
                    (Gujarat, India). Internally segregated into various units,
                    our infrastructure is equipped with latest machinery, tools,
                    instruments and technology that are needed for carrying out
                    production process smoothly and accurately. It is managed by
                    a team of expert professionals, who utilize all the
                    available resources for making a qualitative range as per
                    clients needs. We also have a sophisticated showroom named
                    Harish B. Jariwala at Surat, which is the place, we display
                    all our products. Apart from this, we conduct several tests
                    on final output to ensure zero defect.
                  </p>
                  <p className="text-justify">
                    Under the able and efficient guidance of our mentor, 'Mr.
                    Vishal Jariwala', who has rich experience in this domain, we
                    have carved a niche for ourselves in the market. His ethical
                    business practices, client-centric approaches and sound
                    strategies have enabled us to muster a huge clientele across
                    the Indian Subcontinent, East Asia and North Europe.
                  </p>
                </div>
              </div>
              <div
                className="hidden xl:block absolute lg:top-[80%]
                 lg:-left-[8%] xl:top-[85.5%] xl:-left-[5%]
             2xl:top-0 2xl:left-[30%] 4xl:-top-0 4xl:left-[30%] -z-10"
              >
                <div className="w-24 md:w-28 lg:w-32 2xl:w-36 4xl:w-44 h-full">
                  <img src={Red_Dots} alt="" className="object-cover" />
                </div>
              </div>
              <div className="hidden lg:block absolute lg:bottom-[10%] lg:-right-[11%] xl:bottom-10 xl:-right-[8%]  3xl:bottom-10 3xl:-right-[7%]">
                <div className="lg:w-48 xl:w-[13rem] 3xl:w-60 h-full">
                  <img src={Ring_circle} alt="" className="l" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="relative p-4 my-5 lg:my-2 xl:py-10 overflow-hidden">
        <div className="lg:mx-10 xl:mx-14 2xl:mx-32 3xl:mx-40 4xl:max-w-[1520px] 4xl:mx-auto ">
          <div className="mb-10 xl:mb-20 text-center flex flex-col justify-center gap-2.5 lg:gap-5">
            <h3 className="text-[#222222] text-lg lg:text-3xl font-normal">
              TESTIMONIALS
            </h3>
            <h1 className="text-[#A5302E] text-3xl lg:text-5xl font-medium">
              What Our Clients Say
            </h1>
          </div>
          <Swiper
            slidesPerView={1}
            spaceBetween={50}
            loop={true}
            breakpoints={{
              640: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 2,
                spaceBetween: 50,
              },
            }}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination]}
            className="mySwiper"
          >
            <SwiperSlide>
              <div className="bg-[url('../public/images/background_img/testimonial_bg.png')] p-4 lg:p-8 bg-cover">
                <div className="flex items-center mb-3 lg:mb-7">
                  <svg
                    className="w-5 h-5 lg:w-10 lg:h-10"
                    viewBox="0 0 58 58"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_271_3856)">
                      <path
                        d="M15.8231 48.4109C23.4088 48.4109 28.8856 42.148 28.8856 32.8736C28.8381 19.4003 18.7087 9.87414 4.09534 8.04539C2.74159 7.87439 2.21909 9.75539 3.46596 10.3088C9.07096 12.8025 11.9043 15.966 12.2701 19.0963C12.5432 21.4356 11.2726 23.4853 9.67421 23.87C5.53459 24.8651 2.76059 30.0213 2.76059 35.3484C2.76059 38.8128 4.13681 42.1353 6.58651 44.585C9.0362 47.0347 12.3587 48.4109 15.8231 48.4109ZM44.3231 48.4109C51.9088 48.4109 57.3856 42.148 57.3856 32.8736C57.3381 19.4003 47.2087 9.87414 32.5953 8.04539C31.2416 7.87439 30.7191 9.75539 31.966 10.3088C37.571 12.8025 40.4043 15.966 40.7701 19.0963C41.0432 21.4356 39.7726 23.4853 38.1742 23.87C34.0346 24.8651 31.2606 30.0213 31.2606 35.3484C31.2606 38.8128 32.6368 42.1353 35.0865 44.585C37.5362 47.0347 40.8587 48.4109 44.3231 48.4109Z"
                        fill="#ffff"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_271_3856">
                        <rect
                          width="57"
                          height="57"
                          fill="white"
                          transform="translate(0.385742 0.909424)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>

                <p className="text-[#fff] text-sm lg:text-2xl font-normal">
                  Adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                  dolore magna aliqua ut enim ad minim. Adipiscing elit, sed do
                  eiusmod tempor incididunt ut labore.
                </p>

                <div className="flex items-center gap-5 mt-5 lg:mt-14">
                  <img
                    src={Avtar1}
                    alt=""
                    className="rounded-full h-10 lg:h-14"
                  />
                  <div>
                    <h5 className="text-sm lg:text-[26px] text-[#fff] font-medium lg:mb-0.5">
                      Ann Dowson
                    </h5>
                    <span className="text-[#fff] text-sm lg:text-2xl">
                      Artist
                    </span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="bg-white p-4 lg:p-8">
                <div className="flex items-center mb-3 lg:mb-7">
                  <svg
                    className="w-5 h-5 lg:w-10 lg:h-10"
                    viewBox="0 0 58 58"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_271_3856)">
                      <path
                        d="M15.8231 48.4109C23.4088 48.4109 28.8856 42.148 28.8856 32.8736C28.8381 19.4003 18.7087 9.87414 4.09534 8.04539C2.74159 7.87439 2.21909 9.75539 3.46596 10.3088C9.07096 12.8025 11.9043 15.966 12.2701 19.0963C12.5432 21.4356 11.2726 23.4853 9.67421 23.87C5.53459 24.8651 2.76059 30.0213 2.76059 35.3484C2.76059 38.8128 4.13681 42.1353 6.58651 44.585C9.0362 47.0347 12.3587 48.4109 15.8231 48.4109ZM44.3231 48.4109C51.9088 48.4109 57.3856 42.148 57.3856 32.8736C57.3381 19.4003 47.2087 9.87414 32.5953 8.04539C31.2416 7.87439 30.7191 9.75539 31.966 10.3088C37.571 12.8025 40.4043 15.966 40.7701 19.0963C41.0432 21.4356 39.7726 23.4853 38.1742 23.87C34.0346 24.8651 31.2606 30.0213 31.2606 35.3484C31.2606 38.8128 32.6368 42.1353 35.0865 44.585C37.5362 47.0347 40.8587 48.4109 44.3231 48.4109Z"
                        fill="#A5302E"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_271_3856">
                        <rect
                          width="57"
                          height="57"
                          fill="white"
                          transform="translate(0.385742 0.909424)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>

                <p className="text-[#555555] text-sm lg:text-2xl font-normal">
                  Adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                  dolore magna aliqua ut enim ad minim. Adipiscing elit, sed do
                  eiusmod tempor incididunt ut labore.
                </p>

                <div className="flex items-center gap-5 mt-5 lg:mt-14">
                  <img
                    src={Avtar2}
                    alt=""
                    className="rounded-full h-10 lg:h-14"
                  />
                  <div>
                    <h5 className="text-sm lg:text-[26px] font-medium lg:mb-0.5">
                      Ann Dowson
                    </h5>
                    <span className="text-[#555555] text-sm lg:text-2xl">
                      Artist
                    </span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="bg-white p-4 lg:p-8">
                <div className="flex items-center mb-3 lg:mb-7">
                  <div>
                    <svg
                      className="w-5 h-5 lg:w-10 lg:h-10"
                      viewBox="0 0 58 58"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_271_3856)">
                        <path
                          d="M15.8231 48.4109C23.4088 48.4109 28.8856 42.148 28.8856 32.8736C28.8381 19.4003 18.7087 9.87414 4.09534 8.04539C2.74159 7.87439 2.21909 9.75539 3.46596 10.3088C9.07096 12.8025 11.9043 15.966 12.2701 19.0963C12.5432 21.4356 11.2726 23.4853 9.67421 23.87C5.53459 24.8651 2.76059 30.0213 2.76059 35.3484C2.76059 38.8128 4.13681 42.1353 6.58651 44.585C9.0362 47.0347 12.3587 48.4109 15.8231 48.4109ZM44.3231 48.4109C51.9088 48.4109 57.3856 42.148 57.3856 32.8736C57.3381 19.4003 47.2087 9.87414 32.5953 8.04539C31.2416 7.87439 30.7191 9.75539 31.966 10.3088C37.571 12.8025 40.4043 15.966 40.7701 19.0963C41.0432 21.4356 39.7726 23.4853 38.1742 23.87C34.0346 24.8651 31.2606 30.0213 31.2606 35.3484C31.2606 38.8128 32.6368 42.1353 35.0865 44.585C37.5362 47.0347 40.8587 48.4109 44.3231 48.4109Z"
                          fill="#A5302E"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_271_3856">
                          <rect
                            width="57"
                            height="57"
                            fill="white"
                            transform="translate(0.385742 0.909424)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>

                <p className="text-[#555555] text-sm lg:text-2xl font-normal">
                  Adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                  dolore magna aliqua ut enim ad minim. Adipiscing elit, sed do
                  eiusmod tempor incididunt ut labore.
                </p>

                <div className="flex items-center gap-5 mt-5 lg:mt-14">
                  <img
                    src={Avtar1}
                    alt=""
                    className="rounded-full h-10 lg:h-14"
                  />
                  <div>
                    <h5 className="text-sm lg:text-[26px] font-medium lg:mb-0.5">
                      Ann Dowson
                    </h5>
                    <span className="text-[#555555] text-sm lg:text-2xl">
                      Artist
                    </span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="bg-white p-4 lg:p-8">
                <div className="flex items-center mb-3 lg:mb-7">
                  <svg
                    className="w-5 h-5 lg:w-10 lg:h-10"
                    viewBox="0 0 58 58"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_271_3856)">
                      <path
                        d="M15.8231 48.4109C23.4088 48.4109 28.8856 42.148 28.8856 32.8736C28.8381 19.4003 18.7087 9.87414 4.09534 8.04539C2.74159 7.87439 2.21909 9.75539 3.46596 10.3088C9.07096 12.8025 11.9043 15.966 12.2701 19.0963C12.5432 21.4356 11.2726 23.4853 9.67421 23.87C5.53459 24.8651 2.76059 30.0213 2.76059 35.3484C2.76059 38.8128 4.13681 42.1353 6.58651 44.585C9.0362 47.0347 12.3587 48.4109 15.8231 48.4109ZM44.3231 48.4109C51.9088 48.4109 57.3856 42.148 57.3856 32.8736C57.3381 19.4003 47.2087 9.87414 32.5953 8.04539C31.2416 7.87439 30.7191 9.75539 31.966 10.3088C37.571 12.8025 40.4043 15.966 40.7701 19.0963C41.0432 21.4356 39.7726 23.4853 38.1742 23.87C34.0346 24.8651 31.2606 30.0213 31.2606 35.3484C31.2606 38.8128 32.6368 42.1353 35.0865 44.585C37.5362 47.0347 40.8587 48.4109 44.3231 48.4109Z"
                        fill="#A5302E"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_271_3856">
                        <rect
                          width="57"
                          height="57"
                          fill="white"
                          transform="translate(0.385742 0.909424)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>

                <p className="text-[#555555] text-sm lg:text-2xl font-normal">
                  Adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                  dolore magna aliqua ut enim ad minim. Adipiscing elit, sed do
                  eiusmod tempor incididunt ut labore.
                </p>

                <div className="flex items-center gap-5 mt-5 lg:mt-14">
                  <img
                    src={Avtar2}
                    alt=""
                    className="rounded-full h-10 lg:h-14"
                  />
                  <div>
                    <h5 className="text-sm lg:text-[26px] font-medium lg:mb-0.5">
                      Ann Dowson
                    </h5>
                    <span className="text-[#555555] text-sm lg:text-2xl">
                      Artist
                    </span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
        <div
          className="hidden xl:block absolute lg:top-[80%]
                 lg:-left-[8%] xl:top-[85.5%] xl:-left-[5%]
             2xl:top-16 2xl:left-0 4xl:top-20 4xl:left-0 -z-10"
        >
          <div className="w-24 md:w-28 lg:w-32 2xl:w-full 4xl:w-full h-full">
            <img src={Red_Dots} alt="" className="object-cover" />
          </div>
        </div>
        <div
          className="hidden xl:block absolute top-[6%] right-[35%] xs:top-[5.5%] xs:right-[32%] md:top-[5%] md:right-[38%] 
          lg:top-[24.5%] lg:right-[2%] xl:top-[21.5%] xl:right-[2.5%]
             2xl:top-16 2xl:right-[4%] 4xl:top-16 4xl:right-[3%]"
        >
          <div className="w-3 md:w-5 lg:w-3 xl:w-5 2xl:w-6 4xl:w-20 h-full">
            <img
              src={Red_arrow}
              alt=""
              className="object-cover max-w-full mx-auto rotate-180"
            />
          </div>
        </div>
      </section> */}
      {/* <section className="relative p-4 my-5 lg:my-2 xl:py-10 overflow-hidden">
        <div className="w-full h-full">
          <img
            src={Media_img}
            alt=""
            className="object-cover max-w-full mx-auto z-20"
          />
          <div className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-40">
            <span className="text-white  text-base lg:text-3xl font-medium border-white border w-[50px] h-[50px] lg:w-[200px] lg:h-[200px] flex justify-center items-center rounded-[50%]">
              Play
            </span>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default AboutUs;
